import { withInstall, withNoopInstall } from '@lit-element/utils'
import Tabs from './src/tabs'
import TabPane from './src/tab-pane.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtTabs: SFCWithInstall<typeof Tabs> & {
  TabPane: typeof TabPane
} = withInstall(Tabs, {
  TabPane,
})
export const LtTabPane: SFCWithInstall<typeof TabPane> =
  withNoopInstall(TabPane)
export default LtTabs

export * from './src/tabs'
export * from './src/tab-bar'
export * from './src/tab-nav'
export * from './src/tab-pane'
export * from './src/constants'
